import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Switch } from '../../components/SettingRow';
import { TwoColumnLayout, Column, Section, SectionBlock, SectionTitle } from '../../components/TwoColumnLayout';
import { RadioButtons } from '../../components/RadioButtons';
import { PhoneDirectoryUserInfo } from '../SimsInfoPage/PhoneDirectoryUserInfo';
import { PhoneDirectoryOwnerInfo } from '../SimsInfoPage/PhoneDirectoryOwnerInfo';
import { ServiceLimitProfileSelect } from '../../components/ServiceLimitProfileSelect';
import { RoamingLimitSelect } from '../../components/RoamingLimitSelect';

const SubTitle = styled.p`
	font-size: 1.3rem;
`;

const radioButtonValues = [
	{ displayName: 'Salainen numero', buttonId: 'private-number', displaytext: 'Puhelinnumero ei näy puhelun vastaanottajalle, eikä numeropalveluissa.' },
	{ displayName: 'Puolisalainen numero', buttonId: 'semi-private-number', displaytext: 'Puhelinnumero näkyy puhelun vastaanottajalle, mutta ei numeropalveluissa.' },
	{ displayName: 'Julkinen numero', buttonId: 'public-number', displaytext: 'Puhelinnumero näkyy numeropalveluissa ja puhelun vastaanottajalle.' }
];

class ActivationSimSettings extends React.PureComponent {
	renderChoice(title, variable, description = null) {
		return (
			<SectionBlock>
				<Switch title={title} checked={this.props.settings[variable].value} onChange={(checked) => this.props.onChange(variable, checked)}>
					{description}
				</Switch>
			</SectionBlock>
		);
	}

	render() {
		return (
			<TwoColumnLayout>
				<Column>
					{this.props.accountType === 'business' && (
						<div>
							<SectionTitle>Lisäpalvelut</SectionTitle>
							<Section>{this.renderChoice('Rajaton data (+12 €/simmi/kk)', 'unlimitedData')}</Section>
							<SectionTitle>Palvelut Suomessa</SectionTitle>
							<Section>
								{this.renderChoice(
									'Data-aresti',
									'dataSuspended',
									'Voit kytkeä netin tilapäisesti pois käytöstä ja takaisin päälle. Palvelu aktivoituu sekunneissa. Huomaathan, että tarvitset nettiä myös YritysMoin käyttöön.'
								)}
								{this.renderChoice('Kansainväliset- ja roaming-puhelut', 'internationalCallsAllowed')}
							</Section>
						</div>
					)}
					<SectionTitle>Palvelut ulkomailla</SectionTitle>
					<Section>
						<RoamingLimitSelect
							updating={false}
							value={this.props.settings.roamingLimit.value}
							accountType={this.props.accountType}
							disabled={false}
							onChange={(selected) => this.props.onChange(selected.roamingLimit.name, selected.roamingLimit.value)}
						/>
					</Section>
					<ServiceLimitProfileSelect
						onChange={(value) => this.props.onChange('serviceLimitProfile', value)}
						accountType={this.props.accountType}
						updating={false}
						value={this.props.settings.serviceLimitProfile.value}
					/>
				</Column>

				<Column>
					<SectionTitle>Puhelinnumeron julkisuus</SectionTitle>
					<Section>
						<SectionBlock>
							<RadioButtons
								disabled={false}
								updating={false}
								onChange={(value) => this.props.phoneDirectoryOnChange('privacy', value)}
								name={'privacy'}
								currentValue={this.props.phoneDirectoryUserInfo.privacy}
								values={radioButtonValues}
							/>
							{this.props.phoneDirectoryUserInfo.privacy === 'public-number' && (
								<div>
									<SubTitle>Numeropalveluissa näkyvät tiedot</SubTitle>
									<PhoneDirectoryUserInfo onChange={this.props.phoneDirectoryOnChange} disabled={false} phoneDirectoryFieldNames={['firstName', 'lastName', 'streetAddress', 'zipCode', 'city']} />
									{this.props.accountType === 'business' && (
										<div>
											<Switch
												title="Yrityksen tiedot voi näyttää numeroni ohessa"
												disabled={false}
												infoText={''}
												checked={this.props.phoneDirectoryUserInfo.publishOwner}
												onChange={(value) => this.props.phoneDirectoryOnChange('publishOwner', value)}
											/>
											<PhoneDirectoryOwnerInfo phoneDirectoryOwnerInfo={this.props.phoneDirectoryOwnerInfo} />
										</div>
									)}
								</div>
							)}
						</SectionBlock>
					</Section>
				</Column>
			</TwoColumnLayout>
		);
	}
}
ActivationSimSettings.propTypes = {
	settings: PropTypes.object,
	accountType: PropTypes.string,
	onChange: PropTypes.func,
	phoneDirectoryOwnerInfo: PropTypes.object,
	phoneDirectoryUserInfo: PropTypes.object,
	phoneDirectoryOnChange: PropTypes.func
};

export default ActivationSimSettings;
